import { getFieldErrors } from '@/services/apiError';
import type { PaymentSelection } from '../types/schedule.types';

export const PAYMENT_AMOUNT_FIELD = 'payment_selection.params.amount';

export const PAYMENT_AMOUNT_STALE_ERROR_NAME = 'PaymentAmountStaleError';

export const PAYMENT_RECONFIRM_REASON =
    'The quote total has changed since the payment was set up. Confirm the new amount on the payment step before continuing.';

export const PAYMENT_RECONFIRM_ACTION_LABEL = 'Go to payment step';

export const readPaymentAmountMinor = (selection: PaymentSelection | undefined): number | null => {
    const amount: unknown = selection?.params?.amount;
    return typeof amount === 'number' && Number.isSafeInteger(amount) && amount >= 0 ? amount : null;
};

const isAmountFieldRefusal = (error: unknown): boolean => {
    if (typeof error !== 'object' || error === null) return false;
    if ((error as { status?: unknown }).status !== 422) return false;
    return PAYMENT_AMOUNT_FIELD in getFieldErrors(error);
};

export const isExplainedAmountRefusal = (
    error: unknown,
    selection: PaymentSelection | undefined,
    pricedGrossMinor: number,
): boolean =>
    isAmountFieldRefusal(error) && readPaymentAmountMinor(selection) !== pricedGrossMinor;

export const paymentReconfirmRequired = (
    lastError: unknown,
    selection: PaymentSelection | undefined,
): boolean => {
    if (typeof lastError !== 'object' || lastError === null) return false;
    const { name, grossMinor } = lastError as { name?: unknown; grossMinor?: unknown };
    if (name !== PAYMENT_AMOUNT_STALE_ERROR_NAME || typeof grossMinor !== 'number') return false;
    return readPaymentAmountMinor(selection) !== grossMinor;
};
